<template>
	<Overlay
		ref="overlay"
		class="overlay-editList"
		:root="true"
		:title="title"
		@close="onClose"
	>
		<template v-slot:body>
			<div class="overlay-editList--body">
				{{body}}
			</div>
		</template>
		<template v-slot:footer>
			<div class="footer-actions-group footer-actions-group--right">
				<button
					type="button"
					class="button button--big button--light button--carnation"
					@click="onClose"
				>
					{{cancelButton}}
				</button>
				<button
					type="button"
					class="button button--big button--filled"
					@click="onConfirm"
				>
					{{confirmButton}}
				</button>
			</div>
		</template>
	</Overlay>
</template>

<script src="./CloseFormOverlay.js"></script>
